export const QUOTE_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'declined', label: 'Declined' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const quoteStatusLabel = (v) => (QUOTE_STATUS_OPTIONS.find((o) => o.value === v) || {}).label || v;

export const QUOTE_STATUS_STYLES = {
  draft: 'bg-gray-500/15 text-gray-300 border-gray-500/30',
  sent: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  accepted: 'bg-green-500/15 text-green-400 border-green-500/30',
  declined: 'bg-red-500/15 text-red-400 border-red-500/30',
  cancelled: 'bg-orange-500/15 text-orange-400 border-orange-500/30',
};

export const QUOTE_SORT_OPTIONS = [
  { value: 'recently_updated', label: 'Recently Updated' },
  { value: 'newest_quote_date', label: 'Newest Quote Date' },
  { value: 'oldest_quote_date', label: 'Oldest Quote Date' },
  { value: 'customer_az', label: 'Customer A–Z' },
  { value: 'highest_total', label: 'Highest Customer Total' },
];

export const PRICE_SOURCE_LABELS = { investor: 'Price Book', standard: 'Price Book', custom: 'Custom' };

// Customer activity derived from quote fields (spec §102)
export const customerActivity = (q) => {
  if (q.status === 'draft') return { label: 'Draft', cls: 'text-gray-400' };
  if (q.status === 'accepted') {
    return q.accepted_via === 'customer_link'
      ? { label: 'Approved Online', cls: 'text-green-400' }
      : { label: 'Accepted Internally', cls: 'text-green-400' };
  }
  if (q.status === 'declined') {
    return q.declined_via === 'customer_link'
      ? { label: 'Declined Online', cls: 'text-red-400' }
      : { label: 'Declined Internally', cls: 'text-red-400' };
  }
  if (q.status === 'cancelled') return { label: 'Cancelled', cls: 'text-orange-400' };
  if (q.is_expired) return { label: 'Expired', cls: 'text-amber-400' };
  if (q.customer_view_count > 0) return { label: 'Viewed — Awaiting Response', cls: 'text-[#D4AF37]' };
  return { label: 'Published — Not Viewed', cls: 'text-blue-400' };
};

export const CO_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent' },
  { value: 'approved', label: 'Approved' },
  { value: 'declined', label: 'Declined' },
  { value: 'cancelled', label: 'Cancelled' },
];
export const coStatusLabel = (v) => (CO_STATUS_OPTIONS.find((o) => o.value === v) || {}).label || v;
export const CO_STATUS_STYLES = {
  draft: 'bg-gray-500/15 text-gray-300 border-gray-500/30',
  sent: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  approved: 'bg-green-500/15 text-green-400 border-green-500/30',
  declined: 'bg-red-500/15 text-red-400 border-red-500/30',
  cancelled: 'bg-orange-500/15 text-orange-400 border-orange-500/30',
};
export const signedMoney = (c) => {
  if (c == null) return '—';
  const s = (Math.abs(c) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  return c < 0 ? `-${s}` : c > 0 ? `+${s}` : s;
};
export const coActivity = (co) => {
  if (co.status === 'draft') return { label: 'Draft', cls: 'text-gray-400' };
  if (co.status === 'approved') return co.approved_via === 'customer_link' ? { label: 'Approved Online', cls: 'text-green-400' } : { label: 'Approved Internally', cls: 'text-green-400' };
  if (co.status === 'declined') return co.declined_via === 'customer_link' ? { label: 'Declined Online', cls: 'text-red-400' } : { label: 'Declined Internally', cls: 'text-red-400' };
  if (co.status === 'cancelled') return { label: 'Cancelled', cls: 'text-orange-400' };
  if (co.is_expired) return { label: 'Expired', cls: 'text-amber-400' };
  if (co.customer_view_count > 0) return { label: 'Viewed — Awaiting Response', cls: 'text-[#D4AF37]' };
  return { label: 'Published — Not Viewed', cls: 'text-blue-400' };
};

export const fmtQty = (q) => {
  if (q == null) return '';
  const n = Number(q);
  return Number.isNaN(n) ? q : n.toLocaleString('en-US', { maximumFractionDigits: 6 });
};
